module.exports = __webpack_public_path__ + "static/media/KNX.43b601ad.png";